<template>
  <div class="frpl_game mt-6">
    <div
      class="frpl_game_box f-column text-normal-large weight_500"
      @click.stop="cardDialogIsOpen = true"
    >
      <div v-html="$t('fairplay.select_cards')"></div>
      <div
        class="gw_btn_hover_back mt-4 mr-auto frpl_game_cards_btn"
        style="
          display: flex;
          cursor: pointer;
          gap: 0.5rem;
          --off: 1.5rem;
          --offminus: calc(-0.5 * var(--off));
          --btn-back-inset: var(--offminus) auto auto var(--offminus);
          --btn-back-height: calc(100% + var(--off));
          --btn-back-width: calc(100% + var(--off));
        "
      >
        <PokerCard
          v-for="(card, idx) in l_cards"
          :key="idx"
          class="frpl_game_cards_btn_card"
          :card="card"
          style="
            --height: clamp(1px, 8.125rem, 25vw);
            --value-size-increase: 3.15;
            margin: 0px;
            --gwiz-logo-inline-svg: var(--gwiz-logo-inline-svg-darker);
          "
        >
          <!-- :cardVisual="{
                  cardTheme: 'default_big_symbol',
                  cardBack: 'back_logo',
                }" -->
        </PokerCard>
      </div>
    </div>

    <div class="f-column flex-1">
      <div class="frpl_game_box flex-1 frpl_date text-normal-large weight_500 mb-auto">
        <div class="f-center mb-4 position-relative">
          <div
            class="mr-auto"
            v-html="$t('fairplay.pick_a_date')"
          ></div>
        </div>
        <GwMenu
          ref="time_dialog"
          class="frpl_date-button"
          trigger="click"
          :isEager="true"
          @open="timeDialogIsOpen = true"
          @close="timeDialogIsOpen = false"
        >
          <template #opener>
            <div
              class="gw_btn"
              style="
                --height: 3.25rem;
                font-weight: 500;
                --padding: 0 1rem;
                justify-content: flex-start;
              "
            >
              <i class="mdi mdi-calendar-today text-large mr-2 clr-black" />
              <div class="weight_400">
                <span
                  class="pr-2 text-nowrap"
                  style="font-size: clamp(1px, 1rem, 12vw)"
                >
                  {{ formatedDateInput }}
                </span>
                <span class="text-small clr-grey">
                  {{ timezone }}
                </span>
              </div>
              <i class="mdi mdi-chevron-down text-large ml-auto clr-black" />
            </div>
          </template>
          <template #default="{ methods }">
            <div
              class="gw_menu"
              style="max-width: 100vw"
            >
              <div
                class="f-row text-small clr-grey pr-6 mb-4"
                style="max-width: 35.5rem"
              >
                <div class="mdi mdi-information mr-1" />
                <div v-html="$t('fairplay.picker_info', { minutes: 5 })"></div>
              </div>
              <DatepickerPickers
                ref="datepicker"
                style="max-width: 100vw"
                :localOnly="true"
                :show_time_from="true"
                :show_date_to="false"
                :date_from="formatedDate"
                :time_from="formatedTime"
                :class="{
                  'datepickers_hide-controls': !$store.getters.user_has_flag('UNLIMITEDFAIRPLAY'),
                }"
                :pastDaysAllowed="$store.getters.user_has_flag('UNLIMITEDFAIRPLAY') ? 4200 : 7"
                strDateFromPath="common.date"
                strTimeFromPath="common.time"
                @input:date_from="val => handleDateChanged(val)"
                @input:date_from_time="val => handleTimeChanged(val)"
              >
              </DatepickerPickers>
              <div class="d-flex mt-4">
                <button
                  class="ml-auto gw_btn-v1 gw_btn_primary"
                  @click="$refs.datepicker.emitAll(), methods.toggleOpen(false)"
                >
                  {{ $t('fairplay.confirm') }}
                </button>
              </div>
              <div
                class="mdi mdi-close icon_btn pa-1 csst csst_nm"
                style="position: absolute; top: 0.5rem; right: 0.5rem"
                @click="methods.toggleOpen(false)"
                @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
              >
                <div
                  class="csst_content clr-white text-nowrap pa-1"
                  style="position: fixed"
                  v-html="$t('btn.close')"
                ></div>
              </div>
            </div>
          </template>
        </GwMenu>
      </div>
      <div
        class="w-100 mt-2"
        style="gap: 1rem"
      >
        <div class="csst">
          <div
            v-if="!canConfirm"
            class="csst_content text-nowrap"
            style="position: absolute; right: 0; transform: translate(0, calc(-100% - 2px))"
          >
            {{ $t('fairplay.choose_cards_first') }}
          </div>
          <button
            class="gw_btn-v1 gw_btn_text w-100"
            style="--height: 2.375rem; --padding: 1.5rem 2.5rem"
            :style="
              canConfirm
                ? '--clr-back: var(--clr-primary);'
                : '--clr-back: var(--clr-black-1);--clr: var(--clr-grey-2); pointer-events: none;'
            "
            @click="confirm"
          >
            {{ $t('fairplay.confirm') }}
          </button>
          <!--          <button-->
          <!--            @click="reset"-->
          <!--            class="gw_btn-v1 gw_btn_text"-->
          <!--            style="&#45;&#45;height: 2.375rem; &#45;&#45;padding: 1.5rem 2.5rem; &#45;&#45;border: 1px solid #FDFDFD1A"-->
          <!--            :style="-->
          <!--            canConfirm-->
          <!--              ? '&#45;&#45;clr-back: transparent;'-->
          <!--              : '&#45;&#45;clr-back: transparent;&#45;&#45;clr: var(&#45;&#45;clr-grey-2); pointer-events: none;'-->
          <!--          "-->
          <!--          >-->
          <!--            {{ $t('fairplay.reset') }}-->
          <!--          </button>-->
        </div>
      </div>
    </div>
    <portal to="main_before">
      <FairplayCardsDialog
        :isOpen="cardDialogIsOpen"
        :cards="l_cards"
        @close="cardDialogIsOpen = false"
        @click:confirm="handleCardsDialogConfirm"
      />
    </portal>
  </div>
</template>

<script>
import FairplayCardsDialog from '@/views/fairplay/FairplayCardsDialog'
import DatepickerPickers from '@/components/DataTables/Filters/Datepicker/DatepickerPickers'
import PokerCard from '@/components/Poker/PokerCard/PokerCard'
import GwMenu from '@/components/lib/GwMenu'
import { omit } from 'lodash'
import { parseISO, format, addMinutes } from 'date-fns'
import float_mix from '@/mixins/float_mix'

export const defaultCards = ['E1', 'E2', 'E3', 'E4', 'E5']

const getTimeOffset = () => {
  const date = new Date()
  return date.getTimezoneOffset()
}

export default {
  name: 'FairPlayPicker',
  components: {
    FairplayCardsDialog,
    DatepickerPickers,
    PokerCard,
    GwMenu,
  },
  mixins: [float_mix],
  emits: ['set:game'],
  data() {
    return {
      l_cards: defaultCards,
      time: Date.now(),
      timeDialogIsOpen: false,
    }
  },
  methods: {
    handleScroll(event) {
      if (this.timeDialogIsOpen) this.$refs.time_dialog.toggleOpen(false)
    },
    handleTimeChanged(val) {
      // does not work in safari
      // this.time = new Date(`${this.formatedDate}:${val}`)

      this.time = addMinutes(parseISO(`${this.formatedDate}T${val}Z`), getTimeOffset())
    },
    handleDateChanged(val, type) {
      this.time = addMinutes(parseISO(`${val}T${this.formatedTime}Z`), getTimeOffset())
    },
    handleCardsDialogConfirm(cards) {
      this.l_cards = cards
    },
    reset() {
      this.l_cards = defaultCards
      this.time = Date.now()
    },
    confirm() {
      if (this.canConfirm) {
        this.$emit('set:game', { cards: this.l_cards, time: this.time })
      }
    },
  },
  computed: {
    canConfirm() {
      return this.l_cards !== defaultCards
    },
    cardDialogIsOpen: {
      get() {
        return this.$route.query.fairPlayCardDialog === 'true'
      },
      set(isOpen) {
        if (isOpen) {
          this.$router.push({ query: { ...this.$route.query, fairPlayCardDialog: true } })
          return true
        }
        this.$router.push(omit(this.$route.query, 'fairPlayCardDialog'))
        return false
      },
    },
    formatedDateInput() {
      // TODO use formatISODate to localestring
      return format(this.time, 'MMMM d, yyyy H:mm')
    },
    timezone() {
      return format(this.time, 'OOOO')
    },
    formatedDate() {
      return format(this.time, 'yyyy-MM-dd')
    },
    formatedTime() {
      return format(this.time, 'HH:mm')
    },
  },
}
</script>

<style lang="scss" scoped>
h2 {
  font-weight: 600;
  font-size: 1.75rem;
  margin-bottom: 1.75rem;
}

section {
  margin-bottom: 6.5rem;
  position: relative;
  z-index: 1;
}

.frpl {
  &_game {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    width: 100%;
    &_box {
      flex: 1;
      background: #000;
      border-radius: 8px;
      padding: 1.5rem;
    }
    &_cards {
      &_btn {
        &:hover {
          .frpl_game_cards_btn_card {
            filter: brightness(1.1);
            transition: 0.22s;
          }
        }
      }
    }
  }
}
</style>
